import { render, staticRenderFns } from "./EmailsMandrill.vue?vue&type=template&id=070fb881&"
import script from "./EmailsMandrill.vue?vue&type=script&lang=js&"
export * from "./EmailsMandrill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports